import React from 'react';
import { Header } from './style';
import { Row, OuterIndent, HoverableLink } from '../../Layouts';
import { Icon } from '../../Components/Icons/Icons';
import { ProfileAvatar } from '../../Components/ProfileAvatar/ProfileAvatar';
import { config } from '../../../Configurations';
import { TruncatedText } from '../../UI/Text';
import { generateSlugLink } from '../../../Utils';

export const LeftHeader = ({ smallImage, fullName: name, id }) => {
    return (
        <Header>
            <Row width={'100%'} align={'center'}>
                <HoverableLink target={'_blank'} to={`${generateSlugLink({ name, id })}`}>
                    <Icon.Box size={'40x40'}>
                        <Icon.Logo />
                    </Icon.Box>
                </HoverableLink>

                <OuterIndent indent={'0 20px'}>
                    <ProfileAvatar src={`${config.baseUrl}/${smallImage}`} size={'small'} />
                </OuterIndent>

                <TruncatedText weight={'bold'} fontSize={16}>
                    {name} Check In
                </TruncatedText>
            </Row>
        </Header>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/LeftHeader.js